const cryptoAmountFormat = (amount, currency) => {
    const {base, expoent} = currency.divisibility;
    switch (currency.network) {
        case "eth":
        case "gteth":
            return window.Web3.utils.fromWei(amount, "ether");
        default:
            return amount / Math.pow(base, expoent);
    }
};

export default cryptoAmountFormat;
